import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { DataRangeService } from './services/data-range-service.interface';
import { DataRangeServiceImpl } from './services/data-range-service';
export const pageSelector = new ContainerModule(bind => {
    bind(DataRangeService).to(DataRangeServiceImpl);
});
